import {
    createBudgetCompleted,
    updateBudgetCompleted,
    deleteBudgetCompleted,
} from "actions/collections/collection-budget";
import { calculateCollectionBudget } from "actions/collections/collection-budget-calculation";

import { COLLECTIONS } from "constants/action-types";
import { ajax } from "lib/observable";
import siteConfig from "site-config";

/* DEMO BUDGETS */

const { CREATE, UPDATE, DELETE } = COLLECTIONS.COLLECTION.BUDGET;

export const createBudgetEpic = (action$, store) =>
    action$.ofType(CREATE.START).mergeMap(({ payload: { collectionId, budget } }) =>
        post({
            body: ProtoBudget(budget),
            url: `${siteConfig.goAPI}/v1/collections/${collectionId}/budget_items`,
        })
            .map(({ response }) => response)
            .flatMap(({ data: [protoBudget] }) => [
                createBudgetCompleted(collectionId, Budget(protoBudget)),
                calculateCollectionBudget(protoBudget.id, collectionId),
            ])
    );

export const updateBudgetEpic = (action$, store) =>
    action$.ofType(UPDATE.START).mergeMap(({ payload: { collectionId, budget } }) =>
        put({
            body: { budget_item: ProtoBudget(budget), update_mask },
            url: `${siteConfig.goAPI}/v1/collections/${collectionId}/budget_items/${budget.id}`,
        })
            .map(({ response }) => response)
            .flatMap(({ data: [protoBudget] }) => [
                updateBudgetCompleted(collectionId, Budget(protoBudget)),
                calculateCollectionBudget(protoBudget.id, collectionId),
            ])
    );

export const deleteBudgetEpic = (action$, store) =>
    action$.ofType(DELETE.START).mergeMap(({ payload: { collectionId, budgetId } }) =>
        D_1337({ url: `${siteConfig.goAPI}/v1/collections/${collectionId}/budget_items/${budgetId}` })
            .map(({ response }) => response)
            .flatMap(() => [deleteBudgetCompleted(collectionId, budgetId)])
    );

const get = (options) => ajax({ ...options, method: "GET" });
const post = (options) => ajax({ ...options, method: "POST" });
const put = (options) => ajax({ ...options, method: "PUT" });
const D_1337 = (options) => ajax({ ...options, method: "DELETE" });

const ProtoBudget = ({ name = "UNNAMED", quantity = 0, amount = 0, dimensions = {} }) => ({
    name,
    quantity,
    amount,
    dimensions: Object.keys(dimensions || {}),
    dimension_values: Object.values(dimensions || {}).map((dimension) => ({
        values: Array.isArray(dimension) ? dimension : [dimension],
    })),
});

const Budget = ({ dimensions = [], dimension_values = [], ...budget }) => ({
    ...budget,
    dimensions: dimensions.reduce(
        (target, key, idx) =>
            Object.assign(target, {
                [key]: dimension_values[idx].values[0],
            }),
        {}
    ),
});

const update_mask = {
    paths: ["name", "amount", "quantity", "dimensions", "dimension_values"],
};
